import { render, staticRenderFns } from "./lp-campaign-for-investors.vue?vue&type=template&id=50046266&scoped=true"
import script from "./lp-campaign-for-investors.vue?vue&type=script&lang=js"
export * from "./lp-campaign-for-investors.vue?vue&type=script&lang=js"
import style0 from "./lp-campaign-for-investors.vue?vue&type=style&index=0&id=50046266&prod&scoped=true&lang=css"
import style1 from "./lp-campaign-for-investors.vue?vue&type=style&index=1&id=50046266&prod&lang=css"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50046266",
  null
  
)

export default component.exports